import React from 'react';
import ContactHome from '../../components/ui/ContactHome/ContactHome';

const Contact = () => {
  return (
    <main className="Contact">
      <ContactHome witdh areaSite={'Página de contato'} />
    </main>
  )
}

export default Contact;
